
export const formatPrice = (price: number) => {
  return Math.floor(price).toLocaleString("pl-PL", {
    currency: "PLN",
  });
};


/**
 * Parsuje różne formaty dat i zwraca obiekt Date
 * Obsługuje formaty: DD.MM.YYYY, DD/MM/YYYY, YYYY-MM-DD, DD-MM-YYYY
 */
const parseDateString = (dateString: string): Date | null => {
  if (!dateString || typeof dateString !== "string") {
    return null;
  }

  const trimmedDate = dateString.trim();

  // Format DD.MM.YYYY lub DD/MM/YYYY
  if (trimmedDate.includes(".") || trimmedDate.includes("/")) {
    const separator = trimmedDate.includes(".") ? "." : "/";
    const parts = trimmedDate.split(separator);
    
    if (parts.length === 3) {
      const [day, month, year] = parts;
      const parsedDate = new Date(`${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`);
      
      if (!isNaN(parsedDate.getTime())) {
        return parsedDate;
      }
    }
  }

  // Format YYYY-MM-DD lub DD-MM-YYYY
  if (trimmedDate.includes("-")) {
    const parts = trimmedDate.split("-");
    
    if (parts.length === 3) {
      // Próbujemy określić czy to YYYY-MM-DD czy DD-MM-YYYY
      const firstPart = parseInt(parts[0], 10);
      
      if (firstPart > 1000) {
        // Format YYYY-MM-DD
        const parsedDate = new Date(trimmedDate);
        if (!isNaN(parsedDate.getTime())) {
          return parsedDate;
        }
      } else {
        // Format DD-MM-YYYY
        const [day, month, year] = parts;
        const parsedDate = new Date(`${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`);
        
        if (!isNaN(parsedDate.getTime())) {
          return parsedDate;
        }
      }
    }
  }

  // Próba standardowego parsowania
  const parsedDate = new Date(trimmedDate);
  return !isNaN(parsedDate.getTime()) ? parsedDate : null;
};


export const formatDate = (date: string): string | null => {
  const parsedDate = parseDateString(date);
  
  if (!parsedDate) {
    return null;
  }

  try {
    return parsedDate.toLocaleDateString("pl-PL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return null;
  }
};